import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=e42e5138&scoped=true&lang=pug"
import script from "./ExpenseTable.vue?vue&type=script&lang=js"
export * from "./ExpenseTable.vue?vue&type=script&lang=js"
import style0 from "./ExpenseTable.vue?vue&type=style&index=0&id=e42e5138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42e5138",
  null
  
)

export default component.exports